import React from 'react';

import {Navigate, Outlet} from 'react-router-dom'

const useAuth = () => {
  const user = localStorage.getItem('FF-authUser')
  if(user){
    return true
  } else {
    return false
  }
}

const PublicRoutes=(props) =>{
  const user = localStorage.getItem('FF-authUser')
  const authUser = JSON.parse(user);
    const auth = useAuth()
    return auth ? <Navigate to={authUser.role === 'SuperAdmin' ? "/admins" : "/organizations" } /> : <Outlet />
}

export default PublicRoutes;